module.exports = __webpack_public_path__ + "img/i5.4070aa3f.svg";